/*!
    * @product/scmp-sdk 1.1.45
    * built by undefined
  */
function a(...d){var n;typeof window>"u"||!((n=window)!==null&&n!==void 0&&(n=n.dataLayer)!==null&&n!==void 0&&n.push)||window.dataLayer.push(arguments)}export{a};
//# sourceMappingURL=chunk-HONQW4W2.js.map
